import { ON_REGISTER_ABDM } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

type Response = {
    time: number;
};

export default (): Promise<Response> => {
    return fetchWithRefresh(ON_REGISTER_ABDM, {
        method: 'POST',
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to push register abdm lead from api');
        }
    });
};
